export class MaterialType {
  static Materials = 'Materials';
  static Services = 'Services';
}
